import React from 'react';
import ftwimg from './assets/ftw.png';
import ftwimg2 from './assets/ftw2.png';

function ProjectOne() {
  return (
    <div>
      <h2>for the weirdos, for the world</h2>
      <div style={{ 
        display: 'flex', 
        gap: '2rem', 
        alignItems: 'flex-start',
        flexDirection: 'row',
        flexWrap: 'wrap'
      }}>
        <div id="imageproject" style={{ 
          flex: '0 0 420px',
          maxWidth: '100%'
        }}>
          <p><img src={ftwimg} alt="Weirdo" style={{ 
            width: '100%', 
            maxWidth: '100%', 
            display: 'block',
            height: 'auto'
          }} /></p>
        </div>
        <div id="description" style={{ 
          flex: '1',
          minWidth: '280px'
        }}>
          <p>ftw is a collection of 2100 weirdos inscribed forever on the bitcoin blockchain, weirdos were made by a solo artist/dev/slightly autistic degen, there is no team, no paid shills, no kols, no bs. also no roadmap, no utility, no promises, just art and a simple message.
          ftw is a tribute to the culture, to bitcoin & ordinals and to our lives in the trenches.
          maybe this isn't much, but its honest work 
          </p>
          <p>weirdos were made with love in the trenches with nothing else than a laptop and a touchpad (no mouse). a choice that was made to deliver a raw and honest art.

          weirdos are the results of countless sleepless nights in the trenches and years of blood, sweat and tears combined with a deep rejection of a broken world and a strong desire to escape reality.

          inspired by puppetism, graffiti, modern art, internet culture & his own experiences, the artist used simple art to capturate degeneracy and illustrate complicated feelings.
          </p>
          <p>ftw mint started the 13th of august 2024 and minted out the 15th of august 2024, price was 0.0003btc</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            <a href="https://magiceden.io/ordinals/marketplace/ftw" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">magic eden </a>
            <span style={{ color: 'rgb(170, 170, 170)' }}>-</span>
            <a href="https://discord.com/invite/4pz9wZx6Xt" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">discord</a>
            <span style={{ color: 'rgb(170, 170, 170)' }}>-</span>
            <a href="https://hashlsist" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">hashlist</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectOne; 